import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import * as React from 'react';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from "react-router-dom";
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, where } from 'firebase/firestore'
import { getDownloadURL, getStorage, ref, uploadBytes, listAll } from 'firebase/storage';

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;


// Main function of this page
export default function ProfilePage() {
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [users, setUsers] = useState([])
    const [files, setFiles] = useState([])
    const [avatar, setAvatar] = useState([])

    const [relation, setRelation] = useState([])
    const [recommender, setRecommender] = useState([])
    const [graph, setGraph] = useState([])

    /* Identify the current user */
    const user_email = window.localStorage.getItem('user_email');

    /* Firestore SDK queries */
    useEffect(() => {
      const userQuery = query(
        collection(firestore, 'users'),
        where('email', '==', user_email)
      );
        const unsubscribe = onSnapshot(userQuery, snapshot => {
          setUsers(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })

        return () => {
          unsubscribe()
        }
      }, [])

    /* Storage list functions */
    useEffect(() => {
      listAll(ref(storage, user_email)).then((res) => {
        setFiles(res.items)
      })
    }, [])

    useEffect(() => {
      listAll(ref(storage, user_email+'/Relation Discovery')).then((res) => {
        setRelation(res.items)
      })
    }, [])

    useEffect(() => {
      listAll(ref(storage, user_email+'/Recommender System/')).then((res) => {
        setRecommender(res.items)
      })
    }, [])

    useEffect(() => {
      listAll(ref(storage, user_email+'/Graph Model/')).then((res) => {
        setGraph(res.items)
      })
    }, [])

    /* Show avatar */
    useEffect(() => {
      if (!user_email) {
        setAvatar('https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png')
      } else {
        const avatarRef = ref(storage, user_email+'/avatar.png')
        getDownloadURL(avatarRef)
        .then((url) => {
          setAvatar(url)
        })
        .catch((error) => {
          switch (error.code) {
            case 'storage/object-not-found':
              setAvatar('https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png')
              break;

            case 'storage/unknown':
              console.log("Unknown error!")
              break;
          }})
      }
    }, [])

    /* Upload new pic to change ones avatar */
    const onAvatarChange = async (e) => {
      const pic = e.target.files[0]
      const picRef = ref(storage, user_email+'/avatar.png')
      await uploadBytes(picRef, pic).then((snapshot) => {
        console.log("Uploaded Avatar!")
      })
      alert("Upload successfully!")
      const avatarRef = ref(storage, user_email+'/avatar.png')
      getDownloadURL(avatarRef)
      .then((url) => {
        setAvatar(url)
      })
    }

    const navigate = useNavigate()

    /* Redirect to Onboard page to modify the profile data */
    const handleRedirect = (e) => {
      e.preventDefault()
      alert("Now we will go back to onboarding process to re-set your data.")
      navigate("/Onboard")
    }

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            {/* Sub-Sidebar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                    {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>
                
                <Divider />

                <List component="nav">
                  <ListItemButton href="/Dashboard/Profile" >
                      <ListItemIcon>
                        <AssignmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Personal Info" />
                  </ListItemButton>

                  <ListItemButton href="/Dashboard/Profile/Settings" >
                      <ListItemIcon>
                        <AssignmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Settings" />
                  </ListItemButton>
                </List>
            </Drawer>

            {/* Main space of page*/}
            <Box>
                {/* Title */}
                <Box sx={{ width: '100%' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                        >
                        Ambient / Profile / Personal Info
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                        >
                        Personal Info
                    </Typography>
                </Box>
                
                {/* User profile part */}
                <Box sx={{ mt: 3, ml: 8 }}>
                  <Paper sx={{ display: 'flex', minWidth: 800, minHeight: 60 }}>
                      <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          Avatar: 
                      </Typography>
                      
                      <Box sx={{ ml: 2, mt: 1.5 }}>
                        <Avatar src={avatar} alt='avatar'></Avatar>
                      </Box>

                      <Box sx={{ ml: 6, mt: 1.5 }}>
                        <Button variant="contained" color='primary' component="label">
                          new
                          <input
                            type="file"
                            accept=".png"
                            hidden
                            onChange={onAvatarChange}
                          />
                        </Button>
                      </Box>

                      <Box sx={{ mt: 1.5, ml: 15 }}>
                        <Button variant="contained" color='primary' onClick={handleRedirect}>Edit profile data</Button>
                      </Box>
                  </Paper>

                  {users?.map((row) => (
                    <Paper sx={{ display: 'flex', minWidth: 800, minHeight: 60, mt: 3 }}>
                        <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          Email: {row.data.email}
                        </Typography>

                        <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          Phone: {row.data.phoneNumber}
                        </Typography>
                    </Paper>
                  ))}

                  {users?.map((row) => (
                    <Paper sx={{ display: 'flex', minWidth: 800, minHeight: 60, mt: 3 }}>
                        <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          First name: {row.data.firstName}
                        </Typography>

                        <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          Last name: {row.data.lastName}
                        </Typography>

                        <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          Country: {row.data.country}
                        </Typography>
                    </Paper>
                  ))}

                    {/* List files from Storage */}
                    <Paper sx={{ display: 'flex', minWidth: 800, minHeight: 60, mt: 3 }}>
                      <Typography
                          component="h1"
                          variant="subtitle1"
                          color="inherit"
                          noWrap
                          sx={{ ml: 8, mt: 2 }}
                        >
                          Your file uploaded in database: 
                      </Typography>
                      <List sx={{ ml: 4, mt: 1 }}>
                        {files?.map((row) => (
                          <ListItemText>{row.name}</ListItemText>
                        ))}
                      </List>
                      <List sx={{ ml: 4, mt: 1 }}>
                        {relation?.map((row) => (
                          <ListItemText>{row.name}</ListItemText>
                        ))}
                      </List>
                      <List sx={{ ml: 4, mt: 1 }}>
                        {recommender?.map((row) => (
                          <ListItemText>{row.name}</ListItemText>
                        ))}
                      </List>
                      <List sx={{ ml: 4, mt: 1 }}>
                        {graph?.map((row) => (
                          <ListItemText>{row.name}</ListItemText>
                        ))}
                      </List>
                    </Paper>
                </Box>

              </Box>

        </Box>
    );
}
